import { motion } from "framer-motion";
import { cn } from "./../../../Utils/helper";

const Button = (props) => {
  const { children, handleClick, className, disabled } = props;

  const onClick = () => {
    if (handleClick) handleClick();
  };

  return (
    <motion.button
      className={cn(
        "w-full bg-primary text-white rounded-md h-14 text-xl font-medium disabled:bg-light-grey disabled:text-mid-gray",
        className
      )}
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.96 }}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      {children}
    </motion.button>
  );
};

export default Button;
